export default __webpack_public_path__ + "static/media/Commando.ea19a1fc.jpg";